module.exports = __webpack_public_path__ + "static/inventory-27dc3a6cbe2c7b6d83a6d3a29a017aed.png";